import React from 'react'

import { Container } from 'components/Layout'
import PayWithCreditCardForm from '../PayWithCreditCardForm'

import cn from 'classnames'
import sText from 'components/Text/Text.scss'

export default props => {
  const { bill } = props

  return (
    <Container paddingTop paddingBottom className="sm">
      <div style={{ margin: '0 20px' }}>
        <div className={cn(sText.descrip2, sText.center)}>
          Pay bill: {bill.billNumber} ({bill.reference}) - ${bill.amountDue}
        </div>

        <PayWithCreditCardForm {...props} />
      </div>
    </Container>
  )
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/PayWithCreditCardFormModal/PayWithCreditCardFormModal.jsx